import React from 'react';

const FacebookSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41" version="1.1" x="0px" y="0px">
    <path
      fill="currentColor"
      d="M38.52 0H1.63C.75 0 0 .75 0 1.63v36.66c0 1 .75 1.75 1.63 1.75h19.7V25.02H16.3v-6.25h5.02v-5c0-5.14 3.26-7.76 7.9-7.76 2.26 0 4.14.25 4.65.25v5.38H30.6c-2.5 0-3.13 1.25-3.13 3v4.13h6.27l-1.25 6.25h-5.02l.12 15.02h10.8c.87 0 1.62-.75 1.62-1.63V1.63C40.15.75 39.4 0 38.52 0z"
    />
  </svg>
);

export default FacebookSvg;
